import { render, staticRenderFns } from "./ApprovePreregister.vue?vue&type=template&id=5847397b&scoped=true"
import script from "./ApprovePreregister.vue?vue&type=script&lang=js"
export * from "./ApprovePreregister.vue?vue&type=script&lang=js"
import style0 from "./ApprovePreregister.vue?vue&type=style&index=0&id=5847397b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5847397b",
  null
  
)

export default component.exports